import React, { useEffect, useState } from 'react';
import { NativeBaseProvider, useMediaQuery, } from 'native-base';
import { View, Text, StyleSheet, TouchableOpacity, Linking, StatusBar, BackHandler, Platform } from 'react-native';
import Btn from "../components/btn"
import Colors from '../constants/Colors';
import { Ionicons, MaterialCommunityIcons } from "@expo/vector-icons"
import INPU from '../components/input';

import { useDispatch, useSelector } from 'react-redux';
import AwesomeAlert from 'react-native-awesome-alerts';
import { logOut, walletcharge } from '../store/action/userLogin';
import AsyncStorage from '@react-native-async-storage/async-storage';








const Wallet = (props) => {

    const dispatch = useDispatch();




    const [Wallet1, setWallet1] = useState(false)











    const handleOpencall = (url) => {
        Linking.openURL(url);
    };



    const separate = (num) => {
        const number = num.replace(/\D/g, "")
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    }

    function handleBackButtonClick() {

        setWallet1(true)
        return true;
    }

    useEffect(() => {
        BackHandler.addEventListener("hardwareBackPress", handleBackButtonClick);
        return () => {
            BackHandler.removeEventListener("hardwareBackPress", handleBackButtonClick);
        };
    }, []);




    const logOutHandler = async () => {
        try {
            //   console.log("logout");
            await dispatch(logOut());
            await AsyncStorage.removeItem("access_token");
            props.navigation.navigate("splash");
        } catch (err) {
            console.log(err);
        }
    };
    const handleOpenWithLinking = () => {
        Linking.openURL("https://cutunix.ir/introducing-app/");
    };


    const [isSmallScreen] = useMediaQuery({
        // minHeight: 280,
        // maxHeight: 480,
        maxWidth: 500
    });

    return (
        <NativeBaseProvider>


            <View style={{
                width: isSmallScreen ? "100%" : 500,
                height: "100%",
                backgroundColor: Colors.background,
                position: Platform.OS == "web" ? "fixed" : "relative"
            }}>


                <View style={styles.viewHeader}>
                    <StatusBar backgroundColor={Colors.primary} />

                    <TouchableOpacity style={styles.filter} onPress={() => props.navigation.navigate("ticket")}  >
                        <MaterialCommunityIcons name={"face-agent"} size={30} color={Colors.background} />
                        <Text style={{ fontFamily: "Montserrat", fontSize: 12, color: Colors.background }}>پشتیبانی</Text>
                    </TouchableOpacity>
                    <View style={styles.textheader}>
                        <Text style={{ fontFamily: "MontserratBold", fontSize: 17, color: Colors.background, padding: "5%" }}>
                            پرداخت
                        </Text>
                    </View>

                </View>











                <View style={styles.farsitop}>
                    <Text style={{ fontFamily: "MontserratBold", fontSize: 15, color: Colors.primary, marginRight: 5 }}>استفاده از اپلیکیشن کات یونیکس شامل هزینه می باشد!</Text>
                    <Ionicons name={"alert-circle-outline"}
                        size={20} color={Colors.primary} />

                </View>

                <View style={styles.farsitop1}>
                    <Text style={styles.texttop}>برای ورود به اپلیکیشن باید یکی از مراحل زیر را انتخاب کنید؛</Text>

                </View>

                <View style={styles.farsitop2}>
                    <Text style={styles.texttop}>
                        توجه داشته باشید که با
                        <Text style={{ fontFamily: "MontserratBold", fontSize: 15, color: Colors.primary, }}> وارد کردن کد معرف </Text>
                        از تخفیف ویژه
                    </Text>

                    <Text style={styles.texttop}> برخوردار می شوید. </Text>
                </View>




                <TouchableOpacity onPress={() => props.navigation.navigate("walletCode")} style={{ width: "95%", height: 70, marginTop: "10%", marginLeft: 10, flexDirection: "row", alignItems: "center", justifyContent: "center", borderStyle: 'dashed', borderRadius: 10, borderWidth: 3, borderColor: Colors.primary }}>
                    <Ionicons name={"person-circle"}
                        size={40} color={Colors.primary} />
                    <Text style={{ fontFamily: "MontserratBold", fontSize: 16, color: Colors.black, marginLeft: "10%" }}>وارد کردن کد معرف</Text>

                </TouchableOpacity>

                <TouchableOpacity onPress={() => { handleOpencall(props.route.params.linkprice) }} style={{ width: "95%", height: 70, marginTop: "8%", marginLeft: 10, flexDirection: "row", alignItems: "center", justifyContent: "center", borderStyle: 'dashed', borderRadius: 10, borderWidth: 3, borderColor: Colors.primary }}>
                    <Ionicons name={"cash"}
                        size={40} color={Colors.primary} />
                    <Text style={{ fontFamily: "MontserratBold", fontSize: 16, color: Colors.black, marginLeft: "15%" }}>پرداخت بدون کد</Text>

                </TouchableOpacity>

                <View style={styles.farsitop}>
                    <Text style={{ fontFamily: "MontserratBold", fontSize: 13, color: Colors.black, }}>هزینه استفاده از اپلیکیشن بدون کد معرف {separate(props.route.params.pricing)} ریال می باشد.</Text>
                </View>

                <Btn
                    label="مشاهده امکانات اپلیکیشن"
                    style={{ marginLeft: "5%", marginTop: Platform.OS == "web" ? "25%" : "15%", marginBottom: "5%", height: 55 }}

                    textStyle={{ bottom: 10, fontFamily: "MontserratBold" }}
                    onPress={() => {
                        if (Platform.OS == "web") {
                            handleOpenWithLinking()

                        } else {
                            props.navigation.navigate("web", {
                                addressweb: "https://npln.ir"
                            })
                        }


                    }}
                />







                <AwesomeAlert
                    show={Wallet1}
                    showProgress={false}
                    title="هشدار !"
                    message="از برنامه خارج می شوید؟"
                    closeOnTouchOutside={false}
                    closeOnHardwareBackPress={false}
                    showCancelButton={true}
                    showConfirmButton={true}
                    cancelText="انصراف"
                    confirmText="باشه"
                    confirmButtonColor={Colors.success}
                    cancelButtonColor={Colors.primary}
                    onCancelPressed={() => {
                        setWallet1(false);
                    }}
                    onConfirmPressed={() => {
                        logOutHandler()
                        setWallet1(false);

                    }}
                    titleStyle={{ fontFamily: "MontserratBold", fontSize: 13, color: Colors.primarydark }}
                    messageStyle={{ fontFamily: "Montserrat", fontSize: 13 }}
                    confirmButtonTextStyle={{ fontFamily: "Montserrat", fontSize: 13 }}
                    cancelButtonTextStyle={{ fontFamily: "Montserrat", fontSize: 13 }}

                />

            </View>

        </NativeBaseProvider>
    );
}

const styles = StyleSheet.create({

    viewContainer: {
        width: "100%",
        height: "100%",
        backgroundColor: Colors.background,
        position: Platform.OS == "web" ? "fixed" : "relative"
    },
    viewHeader: {
        flexDirection: "row",
        width: "100%",
        height: Platform.OS == "web" ? 60 : 80,
        backgroundColor: Colors.primary,
    },
    textheader: {
        backgroundColor: Colors.primary,
        width: 100,
        height: 40,
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",

        top: Platform.OS == "web" ? "15%" : "35%"
    },
    menu: {
        backgroundColor: Colors.primary,
        width: 40,
        height: 40,
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
        right: 15,
        top: Platform.OS == "web" ? "15%" : "35%",

    },


    textclose: {
        fontFamily: "Montserrat",
        fontSize: 14,
        color: Colors.background
    },
    farsitop: {
        width: "92%",
        height: 40,
        left: 20,
        top: "8%",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center"
    },
    farsitop1: {
        width: "92%",
        height: 40,
        left: 20,
        top: "15%",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center"
    },
    farsitop2: {
        width: "92%",
        height: 60,
        left: 20,
        marginTop: Platform.OS == "web" ? "30%" : 55,
        alignItems: "center",
        justifyContent: "center"
    },
    texttop: {
        fontFamily: "MontserratBold",
        fontSize: 15,
        color: Colors.black,
    },
    filter: {
        backgroundColor: Colors.primary,
        width: 110,
        height: 40,
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        position: "absolute",
        right: "0%",
        top: Platform.OS == "web" ? "15%" : "35%"
    },


})




export default Wallet